import { useContext, useEffect } from 'react'
import { Button, Container, Grid, Typography } from "@mui/material"
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useGiftRepository } from '../../../../repositories/GiftSubscription/use-gift-repository'
import { Route, STRAPI_URL } from '../../../../router'
import { AppContext } from '../../../../stores/App/AppStore'
import CommonBackButton from '../../../atoms/CommonBackButton/CommonBackButton'
import LocalStorageKeys from '../../../../types/LocalStorageKeys'
import { logLandingPageAction } from '../../../../clients/logger'
import Spacer from '../../../atoms/Spacer/Spacer'
import useTrackPageView from "../../../../helpers/hooks/use-track-page-view"
import useGoogleTagManager from '../../../../helpers/analytics/use-google-tag-manager'
import GtmEventName from '../../../../helpers/analytics/GtmEventName'
import BannerImage from '../../../atoms/BannerImage/BannerImage'
import styles from './SubscriptionGiftRedemptionLandingPointer.module.css'
import GiftPointers from '../../../molecules/GiftPointers/GiftPointers'
import { MyInfoReason } from '../../../../types/MyInfoUserData'

const SubscriptionGiftRedemptionLandingPointer = () => {
    useTrackPageView(`Gift Subscription Landing Page Pointer`)

    const { t } = useTranslation()
    const { code } = useParams()
    const { trackButtonClick } = useGoogleTagManager()
    const { state: appState } = useContext(AppContext)
    const { retrieveGiftSubscriptionLandingPage } = useGiftRepository()

    useEffect(() => {
        if (!appState.pages.giftSubscriptionLandingPage.recipientPointerBannerImageURL){
            retrieveGiftSubscriptionLandingPage()
        }
    }, [])

    const handleNextButton = () => {
        trackButtonClick(GtmEventName.SUBSCRIPTION_GIFT_REDEMPTION_POINTER_SUBMIT)
        localStorage.setItem(LocalStorageKeys.MYINFO_REASON, MyInfoReason.SIGNUP)
        logLandingPageAction(`Sign Up`, `subscriptionGiftLanding`, code)
        window.location.href = `${STRAPI_URL}${Route.MYINFO_AUTHORISE}`
    }

    if (!code){
        return (<Container>
            <CommonBackButton path={Route.HOME} />
            <Typography variant="h4">Error Fetching Subscription Gift</Typography>
        </Container>
        )
    }

    return (
        <Container>
            <CommonBackButton path={Route.HOME} />
            <BannerImage imageUrl={appState.pages.giftSubscriptionLandingPage.recipientPointerBannerImageURL} className={styles.bannerImage} alt="logo"/>
            <Spacer height={20}/>
            <Typography className={styles.title}>{t(`gift_subscription_recipient_pointer_title`)}</Typography>
            <Spacer height={10}/>
            <Typography className={styles.subtitle}>{t(`gift_subscription_recipient_pointer_subtitle`)}</Typography>
            <Spacer height={20}/>
            <GiftPointers pointers={appState.pages.giftSubscriptionLandingPage.recipientPointers ?? []}></GiftPointers>
            <Spacer height={20}/>
            <Typography className={styles.title}>{t(`gift_subscription_recipient_pointer_benefits`)}</Typography>
            <Spacer height={20}/>
            <Grid>
                <Button variant='contained' onClick={handleNextButton} fullWidth>{t(`gift_subscription_recipient_pointer_button`)}</Button>
            </Grid>
        </Container>
    )
}

export default SubscriptionGiftRedemptionLandingPointer